import React from 'react';
import { Box, Tooltip } from '@mui/material';

// Tiny corner pill so staging is obvious without eating a full page row.
// Hover/tap reveals the longer warning text in a tooltip.
const StagingBanner = () => {
  if (process.env.REACT_APP_ENVIRONMENT !== 'staging') {
    return null;
  }

  return (
    <Tooltip
      title="You are on the STAGING environment — data here is not production."
      arrow
    >
      <Box
        sx={{
          position: 'fixed',
          top: 8,
          right: 8,
          zIndex: 9999,
          px: 1,
          py: 0.25,
          borderRadius: 999,
          backgroundColor: 'rgba(255, 152, 0, 0.95)',
          color: 'white',
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: 0.6,
          textTransform: 'uppercase',
          boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
          cursor: 'help',
          userSelect: 'none',
          pointerEvents: 'auto',
        }}
        aria-label="Staging environment"
      >
        ⚠ Staging
      </Box>
    </Tooltip>
  );
};

export default StagingBanner;
